import React from 'react';
import { View, Animated, Easing, StyleSheet, Image } from 'react-native';

const island = require('../../assets/radar/island.png');
const polygon = require('../../assets/radar/polygon.png');
const turtle = require('../../assets/radar/turtle.png');

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: 200,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#329D9C',
    borderRadius: 100,
  },
  circle: {
    width: 200,
    height: 200,
    backgroundColor: 'rgba(242, 242, 242, 0.19)',
    borderRadius: 100,
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle2: {
    width: 140,
    height: 140,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.14)',
    borderRadius: 100,
  },
  circle3: {
    width: 80,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(242, 242, 242, 0.3)',
    borderRadius: 100,
  },
  circle4: {
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginBottom: 25,
    zIndex: 99,
  },
  island: {
    width: 40,
    height: 60,
  },
  polygonContainer: {
    width: 200,
    height: 200,
    justifyContent: 'center',
    alignItems: 'flex-end',
    borderRadius: 100,
    position: 'absolute',
    zIndex: 2,
  },
  polygon: {
    position: 'absolute',
    top: 50,
    width: 100,
    height: 100,
  },
  turtleContainer: {
    position: 'absolute',
    top: 80,
    zIndex: 1,
  },
  turtle: {
    zIndex: 1,
    width: 50,
    height: 50,
  },
});

// eslint-disable-next-line react/prefer-stateless-function
export default class MessageRadar extends React.Component {
  constructor(props) {
    super(props);
    this.spinValue = new Animated.Value(0);
    this.opacityValue = new Animated.Value(0);
  }

  componentDidMount() {
    this.spin();
    this.opacity();
  }

  spin() {
    this.spinValue.setValue(0);
    Animated.timing(this.spinValue, {
      toValue: 1,
      duration: 30000,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start(() => {
      this.spin();
    });
  }

  opacity() {
    this.opacityValue.setValue(0);
    Animated.timing(this.opacityValue, {
      toValue: 0.6,
      duration: 10000,
      easing: Easing.linear,
      useNativeDriver: true,
    }).start(() => {
      this.opacity();
    });
  }

  render() {
    const spin = this.spinValue.interpolate({
      inputRange: [0, 1],
      outputRange: ['0deg', '1440deg'],
    });
    const opacity = this.opacityValue.interpolate({
      inputRange: [0, 0.3, 0.6],
      outputRange: [0.6, 0, 0.6],
    });
    const animatedTurtle = (
      <Animated.View
        style={[
          styles.turtleContainer,
          { opacity },
          //   {
          //     transform: [
          //       { rotateY: '50deg' },
          //       { rotateZ: '45deg' },
          //     ],
          //   },
          //
        ]}
      >
        <Image style={styles.turtle} source={turtle} />
      </Animated.View>
    );

    return (
      <View style={styles.container}>
        <View style={styles.circle}>
          <View style={styles.circle2}>
            <View style={styles.circle3}>
              <View style={styles.circle4}>
                <Image testID="island" style={styles.island} source={island} />
              </View>
              {animatedTurtle}
              <Animated.View
                style={[
                  styles.polygonContainer,
                  {
                    transform: [{ rotate: spin }],
                  },
                ]}
              >
                <Image testID="scanner" style={styles.polygon} source={polygon} />
              </Animated.View>
            </View>
          </View>
        </View>
      </View>
    );
  }
}
